import {
  CONFIG_PAGES,
  ENTITY_NAMES,
  PLATFORM_MODULES,
} from "@miplatform/constants";

export const CONFIG_ROUTE_NAMES = {
  [CONFIG_PAGES.HOME]: "Configuration Home",
  [CONFIG_PAGES.MI_DISPATCH]: PLATFORM_MODULES.MI_DISPATCH,
  [CONFIG_PAGES.MI_SCHEDULING]: PLATFORM_MODULES.MI_SCHEDULING,
  [CONFIG_PAGES.MI_ACCOUNTING]: PLATFORM_MODULES.MI_ACCOUNTING,
  [CONFIG_PAGES.MI_INSPECTIONS]: PLATFORM_MODULES.MI_INSPECTIONS,
  [CONFIG_PAGES.MI_ESTIMATING]: PLATFORM_MODULES.MI_ESTIMATING,
  // TODO: Uncomment when MiAI module is added in backend and planned for
  // [CONFIG_PAGES.MI_AI]: PLATFORM_MODULES.MI_AI,
  [CONFIG_PAGES.TENANTS]: "Tenants",
  [CONFIG_PAGES.HR]: "HR",
  [CONFIG_PAGES.SETTINGS]: "Settings",
  [CONFIG_PAGES.USERS]: "Users",
  [CONFIG_PAGES.ROLES_HR]: "Roles & Permissions",
  [CONFIG_PAGES.ROLES_OPERATIONS]: "Roles & Permissions",
  [CONFIG_PAGES.TEAMS]: "Teams",
  [CONFIG_PAGES.CREATE_TEAM]: "Create Team",
  [CONFIG_PAGES.OPERATIONS]: "Operations",
  [CONFIG_PAGES.ORDER_TEMPLATES]: ENTITY_NAMES.ORDER_TEMPLATES,
  [CONFIG_PAGES.ORDER_CALENDARS]: "Order Calendars",
  [CONFIG_PAGES.WORK_ORDER_CALENDARS]: "Work Order Calendars",
  [CONFIG_PAGES.INSPECTION_CALENDARS]: "Inspection Calendars",
  [CONFIG_PAGES.STEP_TEMPLATES]: ENTITY_NAMES.STEP_TEMPLATES,
  [CONFIG_PAGES.WORK_ORDER_TEMPLATES]: ENTITY_NAMES.WORK_ORDER_TEMPLATES,
  [CONFIG_PAGES.WORK_ORDER_STEPS]: "Work Order Steps",
  [CONFIG_PAGES.RECORDABLES]: "Recordables",
  [CONFIG_PAGES.WARRANTY_ITEMS]: "Warranty Items",
  [CONFIG_PAGES.DELAYS_LIST]: "Delays List",
  [CONFIG_PAGES.TRADE_TYPES]: "Trade Types",
  [CONFIG_PAGES.HOLD_REASONS]: "Hold Reasons",
  [CONFIG_PAGES.CALENDARS]: "Calendars",
  [CONFIG_PAGES.NEW_CONSTRUCTION]: "New Construction",
  [CONFIG_PAGES.BUILD_CALENDAR]: "Build Calendar",
  [CONFIG_PAGES.PRICING]: "Pricing",
  [CONFIG_PAGES.LABOR_RATES]: "Labor Rates",
  [CONFIG_PAGES.INSPECTIONS]: "Inspections",
  [CONFIG_PAGES.INSPECTION_TEMPLATES]: ENTITY_NAMES.INSPECTION_TEMPLATES,
  [CONFIG_PAGES.SETUP]: "Setup",
  [CONFIG_PAGES.DISPATCH]: "Dispatch",
  [CONFIG_PAGES.DEPARTMENTS]: "Departments",
  [CONFIG_PAGES.DEPARTMENT]: "Department",
  [CONFIG_PAGES.ADD_DEPARTMENT]: "Add Department",
  [CONFIG_PAGES.QUICKBOOKS]: "QuickBooks",
  [CONFIG_PAGES.QUICKBOOKS_INTEGRATION]: "QB Integration",
  [CONFIG_PAGES.QUICKBOOKS_IMPORT_CUSTOMERS]: "QB Import",
  [CONFIG_PAGES.DOCUMENT_TYPES]: "Document Types",
  [CONFIG_PAGES.PRODUCTION]: "Production",
  [CONFIG_PAGES.HOLIDAYS]: "Holidays",
  [CONFIG_PAGES.AUTO]: "Automation",
  [CONFIG_PAGES.AUTO_BUILD]: "Auto-Build",
  [CONFIG_PAGES.AUTO_TRIGGER]: "Auto-Trigger",
  [CONFIG_PAGES.AUTO_ASSIGN]: "Auto-Assign",
  [CONFIG_PAGES.MISC]: "Misc",
  [CONFIG_PAGES.INSPECTION_AUTHORITIES]: "Inspection Authorities",
  [CONFIG_PAGES.CITIES]: "Cities",
  [CONFIG_PAGES.MIDAY]: "MiDay",
  [CONFIG_PAGES.CANNOT_PERFORM_REASONS]: "Cannot Perform Reasons",
};
